import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import AdminContactsTab from "@/pages/admin/AdminContactsTab";
import AdminContentTab  from "@/pages/admin/AdminContentTab";
import AdminMediaTab    from "@/pages/admin/AdminMediaTab";

const TABS = [
  { id: "contacts", label: "Inbox · Contacts" },
  { id: "content",  label: "Content · CMS"    },
  { id: "media",    label: "Media · Library"  },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("contacts");

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-[#050505] text-[#f5f5f5]">
      <Toaster theme="dark" position="top-right" richColors closeButton />
      <header className="border-b border-white/10 bg-[#050505]/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <span className="font-mono text-[10px] tracking-[0.4em] text-[#a3a3a3]">R / B</span>
            <span className="w-8 h-px bg-white/30" />
            <span className="font-display text-lg">The Vault</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="overline hidden md:inline">{user?.email}</span>
            <button
              data-testid="admin-logout-btn"
              onClick={handleLogout}
              className="font-mono text-[10px] tracking-[0.3em] uppercase border border-white/20 px-3 py-2 hover:bg-white hover:text-black transition-all"
            >Logout →</button>
          </div>
        </div>
      </header>

      <nav className="border-b border-white/10 bg-[#050505]/80">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex gap-2 overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`font-mono text-[10px] tracking-[0.3em] uppercase px-5 py-4 border-b-2 transition-all whitespace-nowrap ${
                tab === t.id
                  ? "border-[#c01515] text-white"
                  : "border-transparent text-[#a3a3a3] hover:text-white"
              }`}
            >{t.label}</button>
          ))}
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-10">
        {tab === "contacts" && <AdminContactsTab />}
        {tab === "content"  && <AdminContentTab  />}
        {tab === "media"    && <AdminMediaTab    />}
      </main>
    </div>
  );
}
